import Konva from 'konva';

export default class PageOverlay extends Konva.Image {

    pageZeroOverlayImageInstance = undefined;

    constructor(page, overlay, name = 'Page0 Overlay') {
        super(
            {
                x: 0,
                y: 0,
                width: page.width(),
                height: page.height(),
                image: overlay,
                listening: false,
                draggable: false,
            });
        this.obj = name;
    }

    hasHassConfig() {
        return false;
    }

    isContainer() {
        return false;
    }

    isType() {
        return this.obj;
    }
}